// extracted by mini-css-extract-plugin
module.exports =  {"hand":"_93444fe79c--hand--J2uiq","animated":"_93444fe79c--animated--Wb7h1","shake_hand":"_93444fe79c--shake_hand--wlR_p"};